import { setupRecurrenceRulesFormButtons } from '../../lib/form_helpers';

const ManagementFareAdapterConfigurations = {
  init() {
    setupRecurrenceRulesFormButtons();
  }
};

export default ManagementFareAdapterConfigurations;
